<template>
  <div class="assignments-main">
  <BreadCrumb :data="breadCrumb"  />

    <div class="assignments-body">
      <UserCard v-for="user in users" :user='user' :key='user.id'/>
    </div>
  </div>
</template>

<script>
import BreadCrumb from '@/components/BreadCrumb'
import UserCard from './components/UserCard.vue'

const breadCrumb = [
  { label: "Bildirimler", url: "/Ticket/List" },
  { label: "Atamalar", url: "/Ticket/Assignmets" },
]

const users = [
  {id:1, name: 'Alper', assignedTickets: [
    { id: 1, updatedAt: '04.02.2022',
      comments: 9, active: true,
      title: 'IVR Stabil Çalışmıyor'
    }
  ]},
  {id:2, name: 'Alper Can', assignedTickets: [
    { id: 1, updatedAt: '04.02.2022',
      comments: 9, active: true,
      title: 'IVR Stabil Çalışmıyor'
    },
    { id: 2, updatedAt: '14.02.2022',
      comments: 5, active: false,
      title: 'E-posta hatası'
    }
  ]},
  {id:3, name: 'Yadigar', assignedTickets: [
    { id: 1, updatedAt: '04.02.2022',
      comments: 9, active: true,
      title: 'IVR Stabil Çalışmıyor'
    },
    { id: 2, updatedAt: '14.02.2022',
      comments: 5, active: true,
      title: 'E-posta hatası'
    },    { id: 1, updatedAt: '04.02.2022',
      comments: 9, active: true,
      title: 'IVR Stabil Çalışmıyor'
    },
    { id: 2, updatedAt: '14.02.2022',
      comments: 5, active: true,
      title: 'E-posta hatası'
    },    { id: 1, updatedAt: '04.02.2022',
      comments: 9, active: true,
      title: 'IVR Stabil Çalışmıyor'
    },
    { id: 2, updatedAt: '14.02.2022',
      comments: 5, active: true,
      title: 'E-posta hatası'
    },    { id: 1, updatedAt: '04.02.2022',
      comments: 9, active: true,
      title: 'IVR Stabil Çalışmıyor'
    },
    { id: 2, updatedAt: '14.02.2022',
      comments: 5, active: true,
      title: 'E-posta hatası'
    },    { id: 1, updatedAt: '04.02.2022',
      comments: 9, active: true,
      title: 'IVR Stabil Çalışmıyor'
    },
    { id: 2, updatedAt: '14.02.2022',
      comments: 5, active: true,
      title: 'E-posta hatası'
    },    { id: 1, updatedAt: '04.02.2022',
      comments: 9, active: true,
      title: 'IVR Stabil Çalışmıyor'
    },
  ]},
  {id:3, name: 'Yadigar', assignedTickets: [
    { id: 2, updatedAt: '14.02.2022',
      comments: 5, active: true,
      title: 'E-posta hatası'
    },
    { id: 3, updatedAt: '04.02.2022',
      comments: 9, active: false,
      title: 'IVR Stabil Çalışmıyor'
    },
  ]},
  {id:3, name: 'Yadigar', assignedTickets: [
    { id: 2, updatedAt: '14.02.2022',
      comments: 5, active: true,
      title: 'E-posta hatası'
    },
    { id: 3, updatedAt: '04.02.2022',
      comments: 9, active: false,
      title: 'IVR Stabil Çalışmıyor'
    }
  ]},
]

export default {
  name:'Assignments',
  components: {
    BreadCrumb,
    UserCard
  },
  data() {
    return {
      breadCrumb, users
    }
  }
}
</script>

<style>
@import './styles/assignments.min.css';
</style>


// WEBPACK FOOTER //
// src/pages/Support/Ticket/Assignments.vue